export { default as Map } from '@arcgis/core/Map.js';
export { default as Extent } from '@arcgis/core/geometry/Extent.js';
export { default as TileLayer } from '@arcgis/core/layers/TileLayer.js';
export { default as WMTSLayer } from '@arcgis/core/layers/WMTSLayer.js';
export { default as FeatureLayer } from '@arcgis/core/layers/FeatureLayer.js';
export { default as GeoJSONLayer } from '@arcgis/core/layers/GeoJSONLayer.js';
export { default as Color } from '@arcgis/core/Color.js';
export { default as Graphic } from '@arcgis/core/Graphic.js';
export { default as Geometry } from '@arcgis/core/geometry/Geometry.js';
export { default as Point } from '@arcgis/core/geometry/Point.js';
export { default as SimpleMarkerSymbol } from '@arcgis/core/symbols/SimpleMarkerSymbol.js';
export { default as SimpleLineSymbol } from '@arcgis/core/symbols/SimpleLineSymbol.js';
export { default as SimpleRenderer } from '@arcgis/core/renderers/SimpleRenderer.js';
export { default as UniqueValueRenderer } from '@arcgis/core/renderers/UniqueValueRenderer.js';
//export { default as InfoTemplate } from '@arcgis/core/InfoTemplate.js';
export { default as TextSymbol } from '@arcgis/core/symbols/TextSymbol.js';
export { default as LabelClass } from '@arcgis/core/layers/support/LabelClass.js';
export { default as Polyline } from '@arcgis/core/geometry/Polyline.js';
export { default as MapView } from '@arcgis/core/views/MapView.js';
import * as projection from '@arcgis/core/geometry/projection';
import { default as SpatialReference } from '@arcgis/core/geometry/SpatialReference.js';
const WGS84 = SpatialReference.WGS84;

export { projection, SpatialReference, WGS84 };

import esriConfig from '@arcgis/core/config';
esriConfig.assetsPath = '/assets';

export const mapSpatialReference = { wkid: 2193 };
